import Route from '@ember/routing/route';

export default class AuthViewsProposedRoute extends Route {}
